import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import { FaHeart, FaCheckCircle } from "react-icons/fa";
import "./ProductCard.css";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  const {
    addToCart,
    addToWishlist,
    removeFromWishlist,
    wishlist,
  } = useContext(CartContext);

  const [qty, setQty] = useState(1);
  const [message, setMessage] = useState("");

  const isInWishlist = wishlist.some((item) => item.id === product.id);

  // ✅ ADD TO CART
  const handleAddToCart = (e) => {
    e.stopPropagation();

    addToCart({ ...product, qty });
    setQty(1);

    setMessage("Item added to Cart");
    setTimeout(() => setMessage(""), 2500);
  };

  // ✅ WISHLIST
  const handleWishlist = (e) => {
    e.stopPropagation();

    if (isInWishlist) {
      removeFromWishlist(product.id);
      setMessage("Removed from Wishlist");
    } else {
      addToWishlist(product);
      setMessage("Added to Wishlist");
    }

    setTimeout(() => setMessage(""), 2500);
  };

  return (
    <>
      {/* ✅ AMAZON STYLE SUCCESS BAR */}
      {message && (
        <div className="toast">
          <FaCheckCircle className="toast-icon" />
          <span>{message}</span>
          <div className="progress-bar"></div>
        </div>
      )}

      <div className="card">

        {/* IMAGE */}
        <div className="card-img">
          <img
            src={product.images?.[0] || product.image}
            alt={product.name}
            onClick={() => navigate(`/product/${product.id}`)}
          />

          {/* ❤️ WISHLIST */}
          <button
            className={`wishlist-icon ${isInWishlist ? "active" : ""}`}
            onClick={handleWishlist}
          >
            <FaHeart />
          </button>
        </div>

        {/* CONTENT */}
        <div
          className="card-content"
          onClick={() => navigate(`/product/${product.id}`)}
        >
          <h3>{product.name}</h3>
          <p className="price">₹{product.price}</p>

          {/* QTY */}
          <div
            className="qty-selector"
            onClick={(e) => e.stopPropagation()}
          >
            <button onClick={() => setQty(qty > 1 ? qty - 1 : 1)}>-</button>
            <span>{qty}</span>
            <button onClick={() => setQty(qty + 1)}>+</button>
          </div>

          {/* ADD TO CART */}
          <button
            className="cart-btn"
            onClick={handleAddToCart}
          >
            Add To Cart
          </button>
        </div>
      </div>
    </>
  );
};

export default ProductCard;